export default __webpack_public_path__ + "static/media/default.75807719.jpg";